<template>
  <div v-if="items.length > size">
    <!-- SP -->
    <div class="paging-btn">
      <template v-if="currentPage > 0">
        <span v-if="firstLastButton" class="paging-btn_startPage">
          <a @click="first" v-bind:href="anchor">{{buttonLabels.first}}</a>
        </span>
        <span class="paging-btn_prevPage">
          <a @click="prev" v-bind:href="anchor">{{buttonLabels.prev}}</a>
        </span>
      </template>
      <template v-else>
        <span v-if="firstLastButton" class="btn_dummy"></span>
        <span class="btn_dummy"></span>
      </template>
      <span class="paging-btn_numberPage">{{currentPage + 1}} / {{pages}}</span>
      <template v-if="currentPage < (pages - 1)">
        <span class="paging-btn_nextPage">
          <a @click="next" v-bind:href="anchor">{{buttonLabels.next}}</a>
        </span>
        <span v-if="firstLastButton" class="paging-btn_endPage">
          <a @click="last" v-bind:href="anchor">{{buttonLabels.last}}</a>
        </span>
      </template>
      <template v-else>
        <span class="btn_dummy"></span>
        <span v-if="firstLastButton" class="btn_dummy"></span>
      </template>
    </div>
    <!-- PC -->
    <div class="paging-btn-pc">
      <template v-if="currentPage > 0">
        <span v-if="firstLastButton" class="paging-btn_startPage">
          <a @click="first" v-bind:href="anchor">{{buttonLabels.first}}</a>
        </span>
        <span class="paging-btn_prevPage">
          <a @click="prev" v-bind:href="anchor">{{buttonLabels.prev}}</a>
        </span>
      </template>
      <span
        v-for="i in displayPageRange"
        v-bind:key="i">
        <span v-if="i-1 !== currentPage" class="paging-btn_numberPage">
          <a @click="pageSelect(i)" v-bind:href="anchor">{{ i }}</a>
        </span>
        <b v-if="i-1 === currentPage" class="selectPage">{{ i }}</b>
      </span>
      <template v-if="currentPage < (pages - 1)">
        <span class="paging-btn_nextPage">
          <a @click="next" v-bind:href="anchor">{{buttonLabels.next}}</a>
        </span>
        <span v-if="firstLastButton" class="paging-btn_endPage">
          <a @click="last" v-bind:href="anchor">{{buttonLabels.last}}</a>
        </span>
      </template>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Pager',
    props: {
      items: {
        type: Array,
        default: () => [],
        required: true
      },
      size: {
        type: Number,
        default: 10,
        required: false
      },
      startPage: {
        type: Number,
        default: 0,
        required: false
      },
      pageRange: {
        type: Number,
        default: 10,
        required: false
      },
      anchor: {
        type: String,
        default: '#',
        required: false
      },
      firstLastButton: {
        type: Boolean,
        default: false,
        required: false
      },
      buttonLabels: {
        type: Object,
        default: () => {
          return {
            "first": "First",
            "prev": "Back",
            "next": "Next",
            "last": "Last"
          }
        },
        required: false
      }
    },
    data: function () {
      return {
        currentPage: this.startPage
      }
    },
    computed: {
      pages: function () {
        return Math.ceil(this.items.length / this.size);
      },
      displayPageRange: function () {
        const half = Math.ceil(this.pageRange / 2);
        let start, end;

        if (this.pages < this.pageRange) {
          start = 1;
          end = this.pages;

        } else if (this.currentPage < half) {
          start = 1;
          end = start + this.pageRange - 1;

        } else if (this.pages - half < this.currentPage) {
          end = this.pages;
          start = end - this.pageRange + 1;

        } else {
          start = this.currentPage - half + 1;
          end = this.currentPage + half;
        }

        let indexes = [];
        for (let i = start; i <= end; i++) {
          indexes.push(i);
        }
        return indexes;
      }
    },
    methods: {
      first: function () {
        this.currentPage = 0;
        this.selectHandler();
      },
      last: function () {
        this.currentPage = this.pages - 1;
        this.selectHandler();
      },
      prev: function () {
        if (0 < this.currentPage) {
          this.currentPage--;
          this.selectHandler();
        }
      },
      next: function () {
        if (this.currentPage < this.pages - 1) {
          this.currentPage++;
          this.selectHandler();
        }
      },
      pageSelect(index) {
        this.currentPage = index - 1;
        this.selectHandler();
      },
      selectHandler: function () {
        this.$emit('click', this.currentPage);
      }
    },
    watch: {
      items: {
        handler: function () {
          this.first();
        },
        deep: true
      }
    }
  }
</script>
